import React from "react";
// import { useHistory, useLocation } from "react-router-dom";
// import { useAppSelector } from "../../redux/typedHooks";
// import { UserInterface } from "../../types/user";

// legacy logic - Guide steps redirect is disabled as onboarding flow is being updated
const GuideStepsRedirect: React.FC = () => {
  /*
  // legacy logic
  const history = useHistory();
  const location = useLocation();
  const user = useAppSelector<UserInterface | null>(state => state.user.currentUser);

  useEffect(() => {
    if (user && !user.isOnboarding) {
      console.log("Not allowed until boarding complete");
    }

    if (!user || user.isShowGuideSteps === false || !user.isOnboarding || location.pathname === "/choose-user-type") {
      return;
    }

    const currentStep = user.currentStepGuide || 1; // За замовчуванням крок 1
    const currentPath = location.pathname;

    // Визначаємо на яку сторінку потрібно редіректити
    let targetPath = "";

    if (currentStep === 1) {
      // Крок 1 - головна сторінка
      targetPath = "/";
    } else if (currentStep === 2 || currentStep === 3) {
      // Кроки 2 та 3 - сторінка профілю
      targetPath = "/OctaviaSolana";
    } else {
      return;
    }

    // Якщо ми не на потрібній сторінці, редіректимо
    if (targetPath && currentPath !== targetPath) {
      const timeoutId = setTimeout(() => {
        history.push(targetPath);
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [user, location.pathname, history]);
  */

  return null;
};

export default GuideStepsRedirect;

